import config from 'services/table/const';
import { formatDate, currencyFormat } from 'utilities/common';
import Action from './action';

let table = { ...config };
table.url = '/wms/fulfillment/plan';
table.columns = {
  code: {
    title: 'Kode',
    sortable: true,
    width: 80,
    component: (row) => {
      return (
        <div className="text-ellipsis fs-8 fw-semibold text-uppercase">
          {row?.code}
        </div>
      );
    },
  },

  ref_code: {
    title: 'Ref',
    width: 100,
    component: (row) => {
      return (
        <div className="table-col">
          <div className="text-ellipsis fs-8 fw-semibold text-uppercase">
            {row?.ref_code}
          </div>
          <small className="info">{row?.ref_type.replaceAll('_', ' ')}</small>
        </div>
      );
    },
  },

  customer: {
    title: 'Customer',
    width: 100,
    component: (row) => {
      return <div className="text-ellipsis">{row?.customer?.name}</div>;
    },
  },

  recipient_name: {
    title: 'Alamat Penerima',
    sortable: true,
    class: 'text-start',
    width: 150,
    component: (row) => {
      return (
        <div className="table-col">
          <div className="fs-8 fw-semibold">{row?.recipient_name}</div>
          <small className="info text-uppercase text-ellipsis">
            {row?.recipient_region
              ? `${row?.recipient_region?.district_name}, ${row?.recipient_region?.regency_name}, ${row?.recipient_region?.province_name}`
              : null}
          </small>
        </div>
      );
    },
  },

  schedule_at: {
    title: 'Tanggal Pengiriman',
    sortable: true,
    class: 'text-center',
    classHeader: 'text-center',
    width: 100,
    component: (row) => {
      return <div>{formatDate(row?.shipping_date, 'DD/MM/YYYY')}</div>;
    },
  },

  total_weight: {
    title: 'Total Berat',
    sortable: false,
    width: 80,
    class: 'text-end',
    classHeader: 'text-end',
    component: (row) => {
      return (
        <span>{currencyFormat(row?.total_weight / 1000)} Kg </span>
      );
    },
  },

  document_status: {
    title: 'Status',
    sortable: true,
    class: 'text-center',
    classHeader: 'text-center',
    width: 80,
    component: (row) => {
      return (
        <span className={`badge status-${row?.document_status}-lt ms-auto `}>
          {row?.document_status?.replace('_', ' ')?.replace('voided', 'void')}
        </span>
      );
    },
  },

  fulfillment_status: {
    title: 'Fulfillment',
    sortable: true,
    class: 'text-center',
    classHeader: 'text-center',
    width: 80,
    component: (row) => {
      return (
        <span className={`badge status-${row?.fulfillment_status}-lt ms-auto `}>
          {row?.fulfillment_status?.replace('_', ' ')?.replace('voided', 'void')}
        </span>
      );
    },
  },

  created_by: {
    title: 'Dibuat Oleh',
    width: 60,
    component: (row) => {
      return (
        <div className="table-col">
          <div className="text-ellipsis fs-8 fw-semibold text-uppercase">
            {row?.created_by}
          </div>
          <small className="info text-uppercase">
            {formatDate(row?.created_at)}
          </small>
        </div>
      );
    },
  },

  action: {
    title: '',
    width: 40,
    class: 'text-end',
    component: (row) => {
      return <Action data={row} />;
    },
  },
};
export default table;
